export default {
  // Header
  'header.total': 'Total',
  'header.balanceSummary': 'Resumo de Saldos',
  'header.showValues': 'Mostrar valores',
  'header.hideValues': 'Ocultar valores',
  'header.digitalAccount': 'Conta Digital',
  'header.availableBalance': 'Saldo disponível',
  'header.viewStatement': 'Ver extrato',
  'header.incentivePoints': 'Pontos de Incentivo',
  'header.totalAccumulated': 'Total acumulado',
  'header.totalEquity': 'Patrimônio Total',
  'header.accountPlusPoints': 'Conta + Pontos convertidos',
  'header.notifications': 'Notificações',
  'header.markAllAsRead': 'Marcar todas como lidas',
  'header.noNotifications': 'Nenhuma notificação',
  'header.viewAllNotifications': 'Ver todas as notificações',
  'header.deleteNotification': 'Excluir notificação',
  'header.myProfile': 'Meu Perfil',
  'header.companyData': 'Dados da Empresa',
  'header.settings': 'Configurações',
  'header.logout': 'Sair',
  'header.switchCompany': 'Trocar empresa',
  'header.selectCompany': 'Selecione a empresa:',

  // Sidebar
  'sidebar.home': 'Início',
  'sidebar.incentive': 'Incentivo',
  'sidebar.dashboard': 'Dashboard',
  'sidebar.campaigns': 'Campanhas',
  'sidebar.participants': 'Participantes',
  'sidebar.participantsList': 'Lista de Participantes',
  'sidebar.registrations': 'Cadastros',
  'sidebar.sendInvites': 'Enviar Convites',
  'sidebar.performance': 'Performance',
  'sidebar.points': 'Pontos',
  'sidebar.scoring': 'Pontuação',
  'sidebar.buyPoints': 'Comprar Pontos',
  'sidebar.distribution': 'Distribuição',
  'sidebar.deposit': 'Depósito',
  'sidebar.pointsStatement': 'Extrato de Pontos',
  'sidebar.digitalAccountStatement': 'Extrato Conta Digital',
  'sidebar.rewards': 'Recompensas',
  'sidebar.simulator': 'Simulador',
  'sidebar.gamification': 'Gamificação',
  'sidebar.levels': 'Níveis & Progressão',
  'sidebar.badges': 'Distintivos',
  'sidebar.missions': 'Missões & Desafios',
  'sidebar.games': 'Jogos & Sorteios',
  'sidebar.xpRules': 'Regras de XP',
  'sidebar.logs': 'Logs & Histórico',
  'sidebar.analytics': 'Analytics',
  'sidebar.support': 'Suporte',

  // Common buttons
  'button.new': 'Novo',
  'button.edit': 'Editar',
  'button.delete': 'Excluir',
  'button.save': 'Salvar',
  'button.cancel': 'Cancelar',
  'button.confirm': 'Confirmar',
  'button.close': 'Fechar',
  'button.search': 'Buscar',
  'button.filter': 'Filtrar',
  'button.export': 'Exportar',
  'button.import': 'Importar',
  'button.view': 'Visualizar',
  'button.download': 'Baixar',
  'button.upload': 'Enviar',
  'button.add': 'Adicionar',
  'button.remove': 'Remover',
  'button.back': 'Voltar',
  'button.next': 'Próximo',
  'button.previous': 'Anterior',
  'button.finish': 'Finalizar',
  'button.approve': 'Aprovar',
  'button.reject': 'Reprovar',
  'button.send': 'Enviar',

  // Common labels
  'label.name': 'Nome',
  'label.email': 'Email',
  'label.phone': 'Telefone',
  'label.cpf': 'CPF',
  'label.cnpj': 'CNPJ',
  'label.date': 'Data',
  'label.startDate': 'Data Inicial',
  'label.endDate': 'Data Final',
  'label.status': 'Status',
  'label.type': 'Tipo',
  'label.description': 'Descrição',
  'label.value': 'Valor',
  'label.quantity': 'Quantidade',
  'label.total': 'Total',
  'label.actions': 'Ações',
  'label.search': 'Pesquisar',
  'label.filter': 'Filtrar',
  'label.all': 'Todos',
  'label.active': 'Ativo',
  'label.inactive': 'Inativo',
  'label.pending': 'Pendente',
  'label.approved': 'Aprovado',
  'label.rejected': 'Reprovado',
  'label.completed': 'Concluído',
  'label.inProgress': 'Em Andamento',
  'label.scheduled': 'Agendado',
  'label.cancelled': 'Cancelado',

  // Notifications
  'notification.newCampaign': 'Nova campanha disponível',
  'notification.pointsCredited': 'Pontos creditados na sua conta',
  'notification.goalAchieved': 'Meta mensal atingida!',
  'notification.newParticipant': 'Novo participante adicionado',
  'notification.rewardAvailable': 'Prêmio disponível para resgate',

  // Time
  'time.minutesAgo': 'min atrás',
  'time.hoursAgo': 'hora atrás',
  'time.hoursAgoPlural': 'horas atrás',
  'time.daysAgo': 'dia atrás',
  'time.daysAgoPlural': 'dias atrás',

  // Messages
  'message.success': 'Operação realizada com sucesso!',
  'message.error': 'Ocorreu um erro. Tente novamente.',
  'message.confirmDelete': 'Tem certeza que deseja excluir?',
  'message.noData': 'Nenhum dado encontrado',
  'message.loading': 'Carregando...',
  'message.saving': 'Salvando...',

  // Participants
  'participants.title': 'Participantes',
  'participants.list': 'Lista de Participantes',
  'participants.registrations': 'Cadastros',
  'participants.sendInvites': 'Enviar Convites',
  'participants.performance': 'Performance',
  'participants.totalParticipants': 'Total de Participantes',
  'participants.activeParticipants': 'Participantes Ativos',
  'participants.newThisMonth': 'Novos este Mês',
  'participants.averagePoints': 'Média de Pontos',
  'participants.searchPlaceholder': 'Buscar por nome, email ou CPF...',
  'participants.filterByStatus': 'Filtrar por Status',
  'participants.filterByLevel': 'Filtrar por Nível',
  'participants.exportList': 'Exportar Lista',
  'participants.importParticipants': 'Importar Participantes',
  'participants.newParticipant': 'Novo Participante',
  'participants.viewProfile': 'Ver Perfil',
  'participants.viewHistory': 'Ver Histórico',
  'participants.editParticipant': 'Editar Participante',
  'participants.deleteParticipant': 'Excluir Participante',
  'participants.points': 'Pontos',
  'participants.level': 'Nível',
  'participants.registrationDate': 'Data de Cadastro',
  'participants.lastAccess': 'Último Acesso',

  // Dashboard
  'dashboard.title': 'Dashboard de Incentivos',
  'dashboard.subtitle': 'Acompanhe o desempenho das suas campanhas de incentivo',
  'dashboard.activeCampaigns': 'Campanhas Ativas',
  'dashboard.activeParticipants': 'Participantes Ativos',
  'dashboard.distributedPoints': 'Pontos Distribuídos',
  'dashboard.redeemedRewards': 'Prêmios Resgatados',
  'dashboard.vsPreviousPeriod': 'vs período anterior',
  'dashboard.featuredCampaigns': 'Campanhas em Destaque',
  'dashboard.viewAll': 'Ver todas',
  'dashboard.participantsRanking': 'Ranking de Participantes',
  'dashboard.viewFullRanking': 'Ver ranking completo',
  'dashboard.campaignPerformance': 'Performance das Campanhas',
  'dashboard.points': 'Pontos',
  'dashboard.participation': 'Participação',
  'dashboard.redemptions': 'Resgates',
  'dashboard.chartPlaceholder': 'Gráfico de performance será exibido aqui',
  'dashboard.chartSubtitle': 'Dados em tempo real das campanhas ativas',
  'dashboard.quickActions': 'Ações Rápidas',
  'dashboard.createCampaign': 'Criar Campanha',
  'dashboard.newIncentiveCampaign': 'Nova campanha de incentivos',
  'dashboard.distributePoints': 'Distribuir Pontos',
  'dashboard.sendPointsToParticipants': 'Enviar pontos para participantes',
  'dashboard.generateReport': 'Gerar Relatório',
  'dashboard.performanceReport': 'Relatório de performance',
  'dashboard.newCampaign': 'Nova Campanha',
  'dashboard.thisWeek': 'Esta Semana',
  'dashboard.thisMonth': 'Este Mês',
  'dashboard.thisQuarter': 'Este Trimestre',
  'dashboard.thisYear': 'Este Ano',
  'dashboard.active': 'Ativa',
  'dashboard.paused': 'Pausada',
  'dashboard.participants': 'participantes',

  // Participantes - Lista
  participants: {
    title: 'Lista de Participantes',
    subtitle: 'Gerencie todos os participantes do programa de incentivo',
    stats: {
      total: 'Total de Participantes',
      active: 'Participantes Ativos',
      totalCampaigns: 'Total de Campanhas',
      withSupport: 'Com Atendimentos'
    },
    filters: {
      search: 'Buscar por nome ou email...',
      allSegments: 'Todos os Segmentos',
      searchParticipant: 'Buscar por nome, email, CPF ou CNPJ...'
    },
    table: {
      participant: 'Participante',
      department: 'Departamento',
      targetAudience: 'Público-Alvo',
      campaigns: 'Campanhas',
      support: 'Atendimentos (30 dias)',
      actions: 'Ações'
    },
    buttons: {
      newParticipant: 'Novo Participante',
      sendInvites: 'Enviar Convites',
      edit: 'Editar',
      delete: 'Excluir',
      viewCampaigns: 'Ver Campanhas',
      viewSupport: 'Ver Atendimentos',
      save: 'Salvar',
      cancel: 'Cancelar',
      saveChanges: 'Salvar Alterações',
      registerParticipant: 'Cadastrar Participante',
      close: 'Fechar',
      editParticipant: 'Editar Participante',
      managePerformance: 'Gerenciar Performance',
      manageCommunication: 'Gerenciar Comunicação',
      manageContracts: 'Gerenciar Contratos',
      performRegistrations: 'Efetuar Cadastros',
      selectFiles: 'Selecionar Arquivos',
      scheduleShipping: 'Agendar Envio',
      sendInvitesAction: 'Enviar Convites',
      saveTemplate: 'Salvar como Modelo',
      saveModel: 'Salvar Modelo',
      loadModel: 'Carregar Modelo'
    },
    journey: {
      title: 'Jornada dos Participantes',
      subtitle: 'Acompanhe todas as etapas do ciclo de vida dos participantes no programa',
      step1: {
        title: 'Cadastro',
        description: 'Preenchimento de dados pessoais e profissionais',
        details: [
          'Dados pessoais completos',
          'Informações de contato',
          'Dados bancários',
          'Validação de informações',
          'Upload de documentos'
        ],
        stats: {
          complete: 'Completos',
          pending: 'Pendentes'
        }
      },
      step2: {
        title: 'Performance',
        description: 'Registro de vendas de produtos e serviços',
        details: [
          'Cadastro manual de vendas',
          'Importação via CSV',
          'Integração via API',
          'Produtos e serviços',
          'Insumo para metas'
        ],
        stats: {
          records: 'Registros',
          approved: 'Aprovados'
        }
      },
      step3: {
        title: 'Convite',
        description: 'Envio de convites para participação no programa',
        details: [
          'Envio de convites por email',
          'Link de acesso personalizado',
          'Acompanhamento de aceites',
          'Reenvio automático',
          'Controle de pendências'
        ],
        stats: {
          sent: 'Enviados',
          accepted: 'Aceitos'
        }
      },
      step4: {
        title: 'Comunicação',
        description: 'Engajamento e comunicação contínua',
        details: [
          'Notificações de campanhas',
          'Atualizações de pontos',
          'Lembretes de metas',
          'Notificação de Gameficações',
          'Suporte e atendimento'
        ],
        stats: {
          opening: 'Abertura',
          response: 'Resposta'
        }
      },
      step5: {
        title: 'Contratos e Regulamentos',
        description: 'Aceite de termos e documentação legal',
        details: [
          'Termos de participação',
          'Regulamento do programa',
          'LGPD e privacidade',
          'Assinatura digital',
          'Arquivo de documentos'
        ],
        stats: {
          signed: 'Assinados',
          pending: 'Pendentes'
        }
      },
      tracking: {
        title: 'Acompanhamento da Jornada',
        steps: [
          'Cadastro: Valide as informações fornecidas e garanta a completude dos dados',
          'Performance: Registre vendas de produtos e serviços para alimentar metas e gamificação',
          'Convite: Envie convites personalizados e acompanhe a taxa de aceitação em tempo real',
          'Comunicação: Mantenha os participantes engajados com comunicações relevantes e oportunas',
          'Contratos: Assegure que todos os documentos legais sejam aceitos e arquivados corretamente'
        ]
      }
    },
    status: {
      pending: 'Pendente',
      active: 'Ativo',
      inactive: 'Inativo',
      suspended: 'Suspenso',
      paused: 'Pausado',
      completed: 'Concluído'
    },
    campaigns: {
      noCampaigns: 'Nenhuma campanha',
      oneCampaign: '1 campanha',
      multipleCampaigns: 'campanhas',
      activeCampaigns: 'Campanhas Ativas',
      campaignsOf: 'Campanhas de',
      noCampaignsActive: 'Nenhuma campanha ativa',
      notEnrolled: 'Este participante não está inscrito em nenhuma campanha no momento'
    },
    support: {
      noSupport: 'Nenhum',
      oneSupport: '1 atendimento',
      multipleSupport: 'atendimentos'
    },
    modals: {
      register: {
        title: 'Cadastrar Novo Participante',
        subtitle: 'Preencha todas as informações necessárias para o cadastro'
      },
      edit: {
        title: 'Editar Participante'
      },
      invites: {
        title: 'Enviar Convites',
        subtitle: 'Convide participantes para o programa de incentivo',
        recipients: 'Destinatários',
        recipientsNote: 'Apenas participantes com status "Pendente" podem receber convites',
        allPending: 'Todos os participantes pendentes',
        selected: 'Participantes selecionados',
        selectAll: 'Selecionar todos',
        channels: 'Canais de Envio',
        email: 'Email',
        sms: 'SMS',
        whatsapp: 'WhatsApp',
        emailConfig: 'Configuração do Email',
        smsConfig: 'Configuração do SMS',
        whatsappConfig: 'Configuração do WhatsApp',
        subject: 'Assunto',
        message: 'Mensagem',
        variables: 'Variáveis disponíveis',
        variablesNote: 'Use [NOME] para personalizar com o nome do participante e [LINK_CONVITE] para incluir o link de acesso.',
        preview: 'Preview do Email',
        scheduling: 'Agendamento',
        scheduleShipping: 'Agendar Envio',
        date: 'Data',
        time: 'Horário',
        summary: 'Resumo do Envio',
        templates: 'Modelos de Convite',
        saveAsTemplate: 'Salvar como Modelo',
        templateName: 'Nome do Modelo',
        campaigns: 'Campanhas',
        campaignsNote: 'Selecione as campanhas para as quais os participantes serão convidados',
        selectAllCampaigns: 'Selecionar todas as campanhas',
        campaignsSelected: 'Campanhas Selecionadas',
        noCampaignsSelected: 'Nenhuma campanha selecionada. Os participantes receberão apenas o convite geral para o programa.',
        totalInvites: 'Total de Convites',
        byEmail: 'Por Email',
        bySMS: 'Por SMS',
        byWhatsApp: 'Por WhatsApp'
      }
    },
    form: {
      participantType: 'Tipo de Participante',
      individual: 'Pessoa Física',
      company: 'Pessoa Jurídica',
      basicData: 'Dados Básicos',
      fullName: 'Nome Completo',
      companyName: 'Razão Social',
      tradeName: 'Nome Fantasia',
      email: 'Email',
      phone: 'Telefone',
      mobile: 'Celular',
      documents: 'Documentos',
      cpf: 'CPF',
      rg: 'RG',
      birthDate: 'Data de Nascimento',
      maritalStatus: 'Estado Civil',
      profession: 'Profissão',
      cnpj: 'CNPJ',
      stateRegistration: 'Inscrição Estadual',
      companySize: 'Porte da Empresa',
      businessSector: 'Ramo de Atividade',
      address: 'Endereço',
      zipCode: 'CEP',
      street: 'Endereço',
      number: 'Número',
      complement: 'Complemento',
      neighborhood: 'Bairro',
      city: 'Cidade',
      state: 'Estado',
      bankData: 'Dados Bancários',
      bank: 'Banco',
      agency: 'Agência',
      account: 'Conta',
      accountType: 'Tipo de Conta',
      pixKey: 'Chave PIX',
      professionalData: 'Dados Profissionais',
      department: 'Departamento',
      position: 'Cargo',
      admissionDate: 'Data de Admissão',
      salary: 'Salário',
      supervisor: 'Supervisor/Gestor',
      programInfo: 'Informações do Programa',
      initialLevel: 'Nível Inicial',
      initialPoints: 'Pontos Iniciais',
      individualGoal: 'Meta Individual',
      notes: 'Observações',
      settings: 'Configurações',
      receiveNotifications: 'Receber Notificações',
      receiveEmails: 'Receber Emails',
      receiveSMS: 'Receber SMS',
      participateRanking: 'Participar do Ranking',
      uploadDocuments: 'Upload de Documentos',
      dragDrop: 'Arraste e solte os documentos aqui ou clique para selecionar',
      acceptedFormats: 'Formatos aceitos: PDF, JPG, PNG (máx. 5MB cada)',
      selectedDocuments: 'Documentos Selecionados',
      currentPoints: 'Pontos Atuais',
      level: 'Nível',
      joinDate: 'Data de Ingresso'
    },
    details: {
      totalPoints: 'Total de Pontos',
      activeCampaigns: 'Campanhas Ativas',
      support30Days: 'Atendimentos (30d)',
      awards30Days: 'Premiações (30d)',
      campaignsParticipating: 'Campanhas Participando',
      awardsReceived: 'Premiações Recebidas',
      last30Days: 'Últimos 30 dias',
      noAwards: 'Nenhuma premiação nos últimos 30 dias',
      totalAwards: 'Total em Premiações (30 dias)',
      awardReceived: 'premiação recebida',
      awardsReceivedPlural: 'premiações recebidas',
      points: 'Pontos',
      goal: 'Meta',
      ranking: 'Ranking',
      missions: 'Missões',
      support: 'Atend.',
      invites: 'Convites',
      sent: 'env.',
      accepted: 'aceit.',
      communication: 'Comunicações',
      opening: 'abert.',
      response: 'resp.',
      contracts: 'Contratos',
      signed: 'assin.',
      pending: 'pend.',
      totalGeneral: 'Total Geral',
      awards: 'premiações'
    }
  },

  // Participantes - Cadastros
  registrations: {
    title: 'Cadastros de Participantes',
    subtitle: 'Gerencie solicitações de cadastro e aprovações',
    filters: {
      search: 'Buscar por nome ou email...',
      status: 'Status',
      all: 'Todos',
      pending: 'Pendentes',
      approved: 'Aprovados',
      rejected: 'Rejeitados',
      period: 'Período',
      last7days: 'Últimos 7 dias',
      last30days: 'Últimos 30 dias',
      last90days: 'Últimos 90 dias'
    },
    table: {
      name: 'Nome',
      email: 'Email',
      phone: 'Telefone',
      segment: 'Segmento',
      requestDate: 'Data da Solicitação',
      status: 'Status',
      actions: 'Ações'
    },
    actions: {
      viewDetails: 'Ver Detalhes',
      approve: 'Aprovar',
      reject: 'Rejeitar',
      requestAdjustment: 'Solicitar Ajuste'
    },
    stats: {
      pending: 'Pendentes',
      approved: 'Aprovados Hoje',
      rejected: 'Rejeitados',
      approvalRate: 'Taxa de Aprovação'
    }
  },

  // Participantes - Enviar Convites
  invites: {
    title: 'Enviar Convites',
    subtitle: 'Convide novos participantes para o programa',
    form: {
      inviteType: 'Tipo de Convite',
      individual: 'Individual',
      bulk: 'Em Massa',
      name: 'Nome Completo',
      email: 'Email',
      phone: 'Telefone (opcional)',
      segment: 'Segmento',
      selectSegment: 'Selecione o segmento',
      campaign: 'Campanha (opcional)',
      selectCampaign: 'Selecione a campanha',
      message: 'Mensagem Personalizada (opcional)',
      messagePlaceholder: 'Digite uma mensagem de boas-vindas...',
      csvFile: 'Arquivo CSV',
      uploadCSV: 'Fazer Upload do CSV',
      downloadTemplate: 'Baixar Modelo CSV'
    },
    buttons: {
      sendInvite: 'Enviar Convite',
      sendInvites: 'Enviar Convites',
      addAnother: 'Adicionar Outro',
      clear: 'Limpar'
    },
    stats: {
      sent: 'Convites Enviados',
      accepted: 'Aceitos',
      pending: 'Pendentes',
      acceptanceRate: 'Taxa de Aceitação'
    },
    recentInvites: {
      title: 'Convites Recentes',
      email: 'Email',
      sentDate: 'Data de Envio',
      status: 'Status',
      actions: 'Ações',
      resend: 'Reenviar',
      cancel: 'Cancelar'
    }
  },

  // Participantes - Performance
  performance: {
    title: 'Performance dos Participantes',
    subtitle: 'Análise detalhada de desempenho e engajamento',
    filters: {
      period: 'Período',
      last7days: 'Últimos 7 dias',
      last30days: 'Últimos 30 dias',
      last90days: 'Últimos 90 dias',
      thisYear: 'Este Ano',
      segment: 'Segmento',
      allSegments: 'Todos os Segmentos',
      campaign: 'Campanha',
      allCampaigns: 'Todas as Campanhas'
    },
    topPerformers: {
      title: 'Top Performers',
      position: 'Posição',
      participant: 'Participante',
      points: 'Pontos',
      missions: 'Missões',
      rewards: 'Resgates'
    },
    metrics: {
      totalPoints: 'Pontos Totais Distribuídos',
      averagePoints: 'Média de Pontos por Participante',
      completedMissions: 'Missões Completadas',
      redemptionRate: 'Taxa de Resgate'
    },
    engagement: {
      title: 'Engajamento',
      daily: 'Diário',
      weekly: 'Semanal',
      monthly: 'Mensal'
    }
  },

  // Gamificação - Níveis
  levels: {
    title: 'Níveis & Progressão',
    subtitle: 'Configure os níveis de progressão dos participantes',
    buttons: {
      newLevel: 'Novo Nível',
      reorder: 'Reordenar Níveis'
    },
    table: {
      level: 'Nível',
      name: 'Nome',
      xpRequired: 'XP Necessário',
      benefits: 'Benefícios',
      participants: 'Participantes',
      actions: 'Ações'
    },
    stats: {
      totalLevels: 'Total de Níveis',
      averageXP: 'XP Médio por Nível',
      maxLevel: 'Nível Máximo Atingido'
    }
  },

  // Gamificação - Distintivos
  badges: {
    title: 'Distintivos & Conquistas',
    subtitle: 'Gerencie distintivos e conquistas do sistema',
    buttons: {
      newBadge: 'Novo Distintivo',
      categories: 'Categorias'
    },
    filters: {
      search: 'Buscar distintivos...',
      category: 'Categoria',
      allCategories: 'Todas as Categorias',
      rarity: 'Raridade',
      allRarities: 'Todas as Raridades'
    },
    table: {
      badge: 'Distintivo',
      description: 'Descrição',
      category: 'Categoria',
      rarity: 'Raridade',
      criteria: 'Critério',
      earned: 'Conquistados',
      actions: 'Ações'
    }
  },

  // Gamificação - Regras XP
  xpRules: {
    title: 'Regras de XP',
    subtitle: 'Configure como os participantes ganham experiência',
    buttons: {
      newRule: 'Nova Regra',
      categories: 'Categorias de Ações'
    },
    table: {
      action: 'Ação',
      category: 'Categoria',
      xpAmount: 'Quantidade de XP',
      limit: 'Limite',
      status: 'Status',
      actions: 'Ações'
    },
    stats: {
      totalRules: 'Total de Regras',
      averageXP: 'XP Médio por Ação',
      mostUsed: 'Regra Mais Usada'
    }
  },

  // Gamificação - Logs
  logs: {
    title: 'Logs de Atividades',
    subtitle: 'Histórico completo de ações e eventos do sistema',
    filters: {
      search: 'Buscar em logs...',
      type: 'Tipo de Evento',
      allTypes: 'Todos os Tipos',
      period: 'Período',
      last24h: 'Últimas 24h',
      last7days: 'Últimos 7 dias',
      last30days: 'Últimos 30 dias',
      user: 'Usuário',
      allUsers: 'Todos os Usuários'
    },
    table: {
      timestamp: 'Data/Hora',
      user: 'Usuário',
      action: 'Ação',
      details: 'Detalhes',
      ip: 'IP',
      status: 'Status'
    }
  },

  // Gamificação - Analytics
  analytics: {
    title: 'Analytics & Relatórios',
    subtitle: 'Análise detalhada de dados e métricas de gamificação',
    tabs: {
      overview: 'Visão Geral',
      engagement: 'Engajamento',
      progression: 'Progressão',
      rewards: 'Recompensas'
    },
    metrics: {
      totalXP: 'XP Total Distribuído',
      activeUsers: 'Usuários Ativos',
      completionRate: 'Taxa de Conclusão',
      averageLevel: 'Nível Médio'
    }
  },

  // Incentivo - Campanhas
  campaigns: {
    title: 'Campanhas',
    subtitle: 'Gerencie suas campanhas de incentivo',
    buttons: {
      newCampaign: 'Nova Campanha',
      templates: 'Modelos'
    },
    filters: {
      search: 'Buscar campanhas...',
      status: 'Status',
      all: 'Todas',
      active: 'Ativas',
      scheduled: 'Agendadas',
      completed: 'Concluídas',
      paused: 'Pausadas'
    },
    table: {
      campaign: 'Campanha',
      period: 'Período',
      participants: 'Participantes',
      budget: 'Orçamento',
      distributed: 'Distribuído',
      status: 'Status',
      actions: 'Ações'
    },
    stats: {
      active: 'Campanhas Ativas',
      totalBudget: 'Orçamento Total',
      distributed: 'Distribuído',
      participants: 'Participantes'
    }
  },

  // Incentivo - Pontuação
  scoring: {
    title: 'Pontuação',
    subtitle: 'Gerencie regras e distribuição de pontos',
    buttons: {
      newRule: 'Nova Regra',
      distribute: 'Distribuir Pontos'
    }
  },

  // Incentivo - Recompensas
  rewards: {
    title: 'Recompensas',
    subtitle: 'Catálogo de prêmios e resgates',
    buttons: {
      newReward: 'Nova Recompensa',
      categories: 'Categorias'
    },
    filters: {
      search: 'Buscar recompensas...',
      category: 'Categoria',
      allCategories: 'Todas as Categorias',
      availability: 'Disponibilidade',
      all: 'Todas',
      available: 'Disponíveis',
      outOfStock: 'Esgotadas'
    }
  },

  // Incentivo - Extrato de Pontos
  pointsStatement: {
    title: 'Extrato de Pontos',
    subtitle: 'Histórico de movimentações de pontos',
    filters: {
      search: 'Buscar por participante...',
      period: 'Período',
      type: 'Tipo de Movimentação',
      allTypes: 'Todos os Tipos'
    }
  },

  // Incentivo - Simulador
  simulator: {
    title: 'Simulador de Campanhas',
    subtitle: 'Simule resultados e custos de campanhas',
    form: {
      campaignName: 'Nome da Campanha',
      participants: 'Número de Participantes',
      duration: 'Duração (dias)',
      pointsPerAction: 'Pontos por Ação',
      estimatedActions: 'Ações Estimadas por Participante'
    },
    results: {
      title: 'Resultados da Simulação',
      totalPoints: 'Total de Pontos',
      estimatedCost: 'Custo Estimado',
      roi: 'ROI Estimado'
    }
  },

  // Comum
  common: {
    save: 'Salvar',
    cancel: 'Cancelar',
    edit: 'Editar',
    delete: 'Excluir',
    view: 'Visualizar',
    search: 'Buscar',
    filter: 'Filtrar',
    export: 'Exportar',
    import: 'Importar',
    loading: 'Carregando...',
    noData: 'Nenhum dado encontrado',
    confirm: 'Confirmar',
    back: 'Voltar',
    next: 'Próximo',
    previous: 'Anterior',
    close: 'Fechar',
    actions: 'Ações',
    status: 'Status',
    date: 'Data',
    name: 'Nome',
    email: 'Email',
    phone: 'Telefone',
    description: 'Descrição',
  },

  // Menu do Participante
  menu: {
    home: 'Início',
    campaigns: 'Campanhas',
    missions: 'Missões',
    levels: 'Níveis',
    badges: 'Distintivos',
    games: 'Jogos',
    training: 'Treinamento',
    social: 'Social',
    rewards: 'Recompensas',
    statement: 'Extrato',
    support: 'Suporte',
  }
};